export const RESET_ZOOM_BUTTON_SX = {
  textTransform: "none",
  borderColor: "var(--color-gray-300)",
  borderRadius: "10px",
  color: "var(--color-gray-700)",
  backgroundColor: "transparent",
  fontWeight: 600,
  fontSize: "0.8rem",
  px: 2,
  py: 0.7,
  marginBottom: "8px",
  transition: "all 0.2s ease",
  "&:hover": {
    borderColor: "var(--color-accent-active)",
    backgroundColor: "var(--color-accent-lightest)",
    color: "var(--color-accent-active)",
  },
  "&.Mui-disabled": {
    borderColor: "var(--color-border)",
    color: "var(--color-gray-400)",
    backgroundColor: "transparent",
  },
};
